import React, { useEffect, useState } from "react";
import WithRoutify from "../../../hoc/WithRoutify";
import withReduxState from "../../../hoc/wReduxState";
import { decryptString, isSet } from "../../../utils/commonUtils";
import HistoricalVisitService from "../../../services/HistoricalVisitService";
import Buttons from "../../../components/UI/Buttons";
import HistoricalVisitRecordViewModal from "./HistoricalVisitRecordViewModal";

const HistoricalVisitList = (props) => {
  const { patientDetails: patientDetailsFromParent, params, Loader, Toast, setLoader } = props;
  const patientDetails =
    patientDetailsFromParent && Object.keys(patientDetailsFromParent).length > 0
      ? patientDetailsFromParent
      : params?.patientDetails
        ? decryptString(params.patientDetails)
        : {};
  const patientName = isSet(patientDetails.patientName, "—");
  const employeeId = params?.patientId || patientDetails.employee_id;

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewRecordId, setViewRecordId] = useState(null);

  useEffect(() => {
    if (viewRecordId == null) {
      return;
    }
    requestAnimationFrame(() => {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    });
  }, [viewRecordId]);

  useEffect(() => {
    if (!employeeId) {
      setLoading(false);
      return;
    }
    loadHistoricalVisits();
  }, [employeeId]);

  const setLoadingState = (value) => {
    if (setLoader) {
      setLoader(value);
    } else if (Loader) {
      Loader(value);
    }
  };

  const loadHistoricalVisits = async () => {
    try {
      setLoadingState(true);
      setLoading(true);
      const data = await HistoricalVisitService.getEmployeeHistoricalVisits(employeeId, {
        per_page: 50,
      });
      setRows(data?.items || []);
    } catch (err) {
      if (Toast) {
        Toast.error("Unable to load historical visits.");
      }
      setRows([]);
    } finally {
      setLoading(false);
      setLoadingState(false);
    }
  };

  const closeViewModal = () => {
    setViewRecordId(null);
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  };

  return (
    <>
      <div id="home" className="tab-pane active show" role="tabpanel">
        <div className="sh_innerPortview">
          <div className="p-2">
            <div className="sh_cardBox sh_chartboxht shadow-none border">
              <div className="sh_cardHeader">
                <div className="form-group d-flex mb-0 justify-content-between align-items-center">
                  <h6 className="text-sm mb-0">
                    Historical Visit List - {patientName}
                  </h6>
                </div>
              </div>
              <div className="sh_cardBox sh_maincardht position-relative">
                <div className="sh_cardBody sh_cardbglight pt-0 my-1">
                  <div className="p-0 sh_cardbglight">
                    <div className="table-responsive">
                      <table className="table dataTable sh_tablenew nowrap table-hover mb-0" width="100%">
                        <thead>
                          <tr>
                            <th>Provider</th>
                            <th>Visit Date</th>
                            <th>Visit Time</th>
                            <th>MRN / Employee ID</th>
                            <th>Visit category</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan={6} className="text-center text-muted py-4">
                                Loading historical visits…
                              </td>
                            </tr>
                          ) : rows.length === 0 ? (
                            <tr>
                              <td colSpan={6} className="text-center text-muted py-4">
                                No historical visits mapped to this patient yet.
                              </td>
                            </tr>
                          ) : (
                            rows.map((row) => (
                              <tr key={`${row.batch_id}-${row.file_index}`}>
                                <td className="forTable_textEllipsis" title={row.provider_name}>
                                  {row.provider_name}
                                </td>
                                <td>{row.visit_date}</td>
                                <td>{row.visit_time}</td>
                                <td>{row.extracted_mrn}</td>
                                <td className="forTable_textEllipsis" title={row.visit_category}>
                                  {row.visit_category}
                                </td>
                                <td>
                                  <div className="actionTable">
                                    <Buttons
                                      className="btn btn-icon btn-transparent-dark"
                                      iconType="Search"
                                      label=""
                                      acl="any"
                                      title="View details"
                                      clickHandler={() => setViewRecordId(row.record_id)}
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <HistoricalVisitRecordViewModal
        isOpen={viewRecordId != null}
        recordId={viewRecordId}
        employeeId={employeeId}
        onClose={closeViewModal}
        Loader={Loader}
        Toast={Toast}
      />
    </>
  );
};

export default withReduxState(WithRoutify(HistoricalVisitList));
